import { IAppState } from 'shared/common/state';

export function selectCallbackWidgetOpened(state: IAppState) {
  return state.newbuildingBrokerCallbackWidget.callbackWidgetOpened;
}
